
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscribe/returntoapp",
      function () {
        return require("private-next-pages/subscribe/returntoapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subscribe/returntoapp"])
      });
    }
  